import { VALTYPES } from '../../../../data/interfaces';
import { CONFIGPARAMTYPES, createConfigParamTypeRange } from '../../helpers/configParams';
import { CONFIGPARAM_VISIBILITYCONDITION_TYPES, TpChartManifest } from '../interfaces';
import { Histogram } from './Histogram';

export const manifestHistogram: TpChartManifest = {
  id: 'Histogram',
  name: 'Histogram',
  description:
    'Visualizes the distribution of a numerical property by dividing its range in a number of bins, and displaying the number of values in each bin.',
  component: Histogram,
  canvasBased: true,
  groups: [{ groupId: 'values', groupName: 'Values' }],
  aspects: [
    {
      id: 'value',
      name: 'Values data',
      groupId: 'values',
      description: 'Values to be used in the histogram',
      required: true,
      quality: 1,
      dataType: [VALTYPES.NUMBER, VALTYPES.INTEGER],
    },
  ],
  configParams: [
    {
      id: 'resolution',
      name: 'Resolution',
      groupId: 'values',
      description: 'Used to tune the number of bins in the histogram.',
      paramType: createConfigParamTypeRange(1, 10, 1, 5),
      visibilityConditions: [
        {
          conditionType: CONFIGPARAM_VISIBILITYCONDITION_TYPES.CONFIG_ABSENT,
          conditionInfo: {
            configParam: 'fixedBinSize',
          },
        },
      ],
    },
    {
      id: 'minVal',
      name: 'Minimum value',
      groupId: 'values',
      description: 'Sets a fixed minimum value for the histogram displayed range.',
      paramType: { configParamTypeId: CONFIGPARAMTYPES.Value },
    },
    {
      id: 'maxVal',
      name: 'Maximum value',
      groupId: 'values',
      description: 'Sets a fixed maximum value for the histogram displayed range.',
      paramType: { configParamTypeId: CONFIGPARAMTYPES.Value },
    },
    {
      id: 'fixedBinSize',
      name: 'Fixed bin size',
      groupId: 'values',
      description: 'Sets a fixed size for the histogram bins.',
      paramType: { configParamTypeId: CONFIGPARAMTYPES.Value },
    },
    {
      id: 'indicatedValues',
      name: 'Indicated values',
      description: 'Visual indications of specific values on the chart (e.g. a threshold p-value, a cutoff, ...).',
      hidden: true,
      groupId: '',
      paramType: {
        configParamTypeId: CONFIGPARAMTYPES.JSON,
        schema: {
          type: 'array',
          items: {
            type: 'object',
            title: 'Value',
            description: 'An individual value to indicate.',
            properties: {
              value: { type: 'number' },
              label: { type: 'string' },
              color: {
                type: 'array',
                minItems: 3,
                maxItems: 4,
                description: 'The line color, specified as RGB values between 0 and 255',
                items: { type: 'number' },
              },
              lineWidth: { type: 'number' },
              mask: {
                type: 'string',
                description:
                  'Displays a masked area, e.g. to illustrate that the indicated value respresents a threshold.',
                enum: ['left', 'right'],
              },
            },
            required: ['value', 'color'],
          },
        },
      },
    },
  ],

  examples: [
    {
      id: 'histo_2',
    },
  ],
};
